export const expertiseOptions = [
  'Coding Education',
  'STEM (Science, Technology, Engineering, and Math)',
  'EdTech (Educational Technology)',
  'Content Creation (YouTube, Blogging, Social Media)',
  'K-12 Education',
  'Higher Education',
  'Parenting and Educational Resources',
  'Coding Bootcamps or Tutoring',
  'Gaming and Coding',
  'Tech Reviews and Tutorials',
  'AI and Machine Learning',
  'Web Development',
  'App Development',
  'Youth and Community Leadership in Technology',
  'Digital Marketing and Online Learning Platforms',
];
export const promotionPlatformsOptions = [
  'YouTube Channel',
  'Blog or Website',
  'Instagram',
  'Facebook',
  'Twitter (X)',
  'TikTok',
  'LinkedIn',
];
